export default {
  stats: {
    table: {
      rank: "Ranking",
      name: "Nome",
    },
    legend: {
      title: "Legenda",
    },
    filters: {
      titles: {
        week: "Settimana",
        round: "Turno",
        split: "Split",
      },
      options: {
        all: "Tutti",
        qualifier: {
          cumulativeStats: "Totale",
          perGame: "Per partita",
        },
      },
    },
  },
};
